import { render } from "./RouteCard.vue?vue&type=template&id=10361a3c&scoped=true&lang=pug"
import script from "./RouteCard.vue?vue&type=script&lang=ts"
export * from "./RouteCard.vue?vue&type=script&lang=ts"

import "./RouteCard.vue?vue&type=style&index=0&id=10361a3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10361a3c"

export default script